import { createStore, applyMiddleware, compose } from 'redux'
import { createLogger } from 'redux-logger'
import thunkMiddleware from 'redux-thunk'
import promiseMiddleware from 'redux-promise-middleware'
import reducers from '../reducers'

export default (initialState = {}) => {
  const middlewares = [thunkMiddleware, promiseMiddleware()]

  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(createLogger({ collapsed: true }))
  }

  const composedStore = compose(
    applyMiddleware(...middlewares)
  )

  const storeCreator = composedStore(createStore)
  return storeCreator(reducers, initialState)
}



// WEBPACK FOOTER //
// ./src/store/initStore.js